var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"pasteBox",staticClass:"paste-uploader",attrs:{"contenteditable":"true","placeholder":"点击后请将图片粘在此处"},on:{"blur":_vm.blurInput,"paste":_vm.imgPasteHandle}})])}
var staticRenderFns = []

export { render, staticRenderFns }